// Lazy-loaded markdown editor with live preview (@uiw/react-md-editor).
// Used for provider About docs and workspace Skill SKILL.md authoring.
// Consumer-facing render still goes through renderSkillMarkdown (safe HTML).

import React, { Suspense, lazy } from 'react';

const MDEditor = lazy(() => import('@uiw/react-md-editor'));

// Keep editor CSS out of the main bundle — only load with the editor chunk.
import('@uiw/react-md-editor/markdown-editor.css').catch(() => {});

export function MarkdownEditor({
  value,
  onChange,
  height = 360,
  placeholder = 'Write Markdown…',
  maxLength = 100_000,
}) {
  const len = String(value || '').length;
  const over = maxLength != null && len > maxLength;

  return (
    <div data-color-mode="dark" className="xapi-md-editor">
      <Suspense
        fallback={
          <div
            className="input"
            style={{ minHeight: height, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--fg-3)' }}
          >
            Loading editor…
          </div>
        }
      >
        <MDEditor
          value={value || ''}
          onChange={(v) => onChange?.(v ?? '')}
          height={height}
          preview="live"
          visibleDragbar={false}
          textareaProps={{ placeholder }}
        />
      </Suspense>
      <div
        className="micro"
        style={{
          marginTop: 6,
          textAlign: 'right',
          color: over ? 'var(--danger, #dc2626)' : 'var(--fg-4)',
        }}
      >
        {len.toLocaleString()}
        {maxLength != null ? ` / ${maxLength.toLocaleString()}` : ''} chars
        {over ? ' — over limit' : ''}
      </div>
    </div>
  );
}

export default MarkdownEditor;
